import React from 'react'
import styled from 'styled-components'
import { QUIZ_DIAGNOSTICS_PROGRESS_BAR_HEIGHT } from '../utils/quizDiagnosticsBarLayout'

const DASH_LINE_COLOR = '#C5C6C8'

const QuizDiagnosticsDashedLines = (): JSX.Element => (
  <Container>
    <Line />
    <Line />
    <Line />
    <Line />
    <Line />
  </Container>
)

export default QuizDiagnosticsDashedLines

const Container = styled.div`
  height: ${QUIZ_DIAGNOSTICS_PROGRESS_BAR_HEIGHT}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: absolute;
  left: 0;
  top: 54px;
  pointer-events: none;
  opacity: 0.5;
`

const Line = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed ${DASH_LINE_COLOR};
`
